<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="d-flex align-items-center mb-2">
          <i class="fas fa-info-circle mr-2 text-orange"></i>
          <div class="color-gray-7 font-16 font-weight-bold">
            Descripción del Equipo
          </div>
        </div>
        <div class="col-12">
          <span class="data-title">Descripción:</span>
          <p>{{ item.description | empty }}</p>
        </div>
        <div class="col-12">
          <span class="data-title">Datos de Ubicación / Dirección:</span>
          <p>{{ item.address | empty }}</p>
        </div>
      </div>
    </div>
    <div class="row" v-if="showAdditionalInfo">
      <div class="col-12">
        <div class="d-flex align-items-center mb-2">
          <i class="fas fa-plus-circle mr-2 text-orange"></i>
          <div class="color-gray-7 font-16 font-weight-bold">
            Accesorios Asignados al Equipo
          </div>
        </div>
        <div class="col-12">
          <div class="row">
            <div
              class="col-12 col-lg-3 bg-gray rounded d-flex justify-content-between p-2 mr-2 mb-2"
              v-for="(accessory, index) in item.accessories"
              :key="index"
            >
              <div>
                <p class="font-16 font-weight-bold mb-0">
                  {{ accessory.name }}
                </p>
                <p class="font-14">
                  <span class="text-muted">
                    {{ accessory.id }}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AdditionalInfo',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    showAdditionalInfo() {
      return this.item.accessories.length > 0;
    },
  },
};
</script>
<style lang="scss"></style>
